// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__21kv8","balanceDisclaimer":"posDashboard_balanceDisclaimer__jPcss"};